import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/styles";

const responsiveText = (mobileText, desktopText) => {
  return useMediaQuery(useTheme().breakpoints.down(470)) ? mobileText : desktopText;
};

export default responsiveText;
